import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbAssetFiscalClearVoucherView from './AssetFiscalClearVoucherView';
import SwbAssetFiscalEnterVoucherView from './AssetFiscalEnterVoucherView';
Vue.regist(SwbAssetFiscalClearVoucherView);

import fiscalBizApi from '../../api/fiscalBiz';

export function getRealComSysBizState(sysBizTypeCode /* 必传 */, callback, realComId, realComCode /* realComId、realComCode二者至少传一个，不传默认当前上下文中的公司 */, bizMonth /* 不传默认当前月 */) {
    let postData = {};
    postData.realComId = realComId;  // 实体公司
    postData.realComCode = realComCode;  // 实体公司编码
    postData.bizMonth = bizMonth;  // 业务发生月份（yyyyMMdd）
    postData.sysBizTypeCode = sysBizTypeCode;  // 系统业务类型code
    fiscalBizApi.getRealComSysBizStateByUk(postData, function (result) {
        if(result.type === "info") {
            callback(result.data);
        } else {
            MsgBox.warning(result.message);
        }
    });
}

// 清理出账单查看
export function openAssetFiscalClearVoucherDetailDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: "变卖清理单 - 详情",
        width: -200,
        height: 850,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-asset-fiscal-clear-voucher-view :id="id" ref="swb_asset_fiscal_clear_voucher_view"></swb-asset-fiscal-clear-voucher-view>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbAssetFiscalEnterVoucherView);

// 资产入账单
export function openAssetFiscalEnterVoucherDetailDlg(id) {
    let theDlg = Vue.$showDialog({
        title: "资产入账单 - 详情",
        width: -200,
        height: 850,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-asset-fiscal-enter-voucher-view :id="id" ref="swb_asset_fiscal_enter_voucher_view"></swb-asset-fiscal-enter-voucher-view>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbDeprAdjustTypeSelect from './DeprAdjustTypeSelect';
Vue.regist(SwbDeprAdjustTypeSelect);
// 选择调整类型
export function openDeprAdjustTypeSelectDlg(type, callback) {   // 2021-01-19  已作废，不再使用
    let theDlg = Vue.$showDialog({
        title: "调整类型 - 选择",
        width: 500,
        height: 400,
        showCloseBtn: true,
        template: '<swb-depr-adjust-type-select :type="type" ref="swb_depr_adjust_type_select"></swb-depr-adjust-type-select>',
        data: {
            type: type
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_depr_adjust_type_select.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let adjustType = result.data;
                    //
                    callback(adjustType, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbAssetDeprAdjustVoucherSave from './AssetDeprAdjustVoucherSave';
Vue.regist(SwbAssetDeprAdjustVoucherSave);
// 调整单新增
export function openAssetDeprAdjustVoucherSaveDlg(dlgConfig, callback) {
    let id = dlgConfig['id'] || null;
    // 验收单信息 - ids用于过滤选择资产信息
    let receiptId = dlgConfig['receiptId'] || null;     // 验收单Id
    let mulitiWorth = dlgConfig['mulitiWorth'];
    //
    let deviceXId = dlgConfig['deviceXId'] || null;
    let deviceXIds = dlgConfig['deviceXIds'] || [];
    let bizVoucherType = Utils.isNoB(dlgConfig['bizVoucherType']) ? null : dlgConfig['bizVoucherType'];
    let bizVoucherNo = Utils.isNoB(dlgConfig['bizVoucherNo']) ? null : dlgConfig['bizVoucherNo'];
    let readyAdjust = Utils.isTrue(dlgConfig['readyAdjust']); // 待调整标识
    let assetList = dlgConfig['assetList'] || []; // 待调整资产列表
    let theDlg = Vue.$showDialog({
        title: "调整单 - 新增",
        width: -200,
        height: 850,
        showCloseBtn: true,
        template: '<swb-asset-depr-adjust-voucher-save :mulitiWorth="mulitiWorth" :id="id" :receiptId="receiptId" :deviceXId="deviceXId" :deviceXIds="deviceXIds" :bizVoucherType="bizVoucherType" :bizVoucherNo="bizVoucherNo" :readyAdjust="readyAdjust" :assetList="assetList" ref="swb_asset_depr_adjust_voucher_save"></swb-asset-depr-adjust-voucher-save>',
        data: {
            id: id,
            receiptId: receiptId,
            //
            deviceXId: deviceXId,
            deviceXIds: deviceXIds,
            bizVoucherType: bizVoucherType,
            bizVoucherNo: bizVoucherNo,
            mulitiWorth: mulitiWorth,
            readyAdjust: readyAdjust,
            assetList: assetList
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asset_depr_adjust_voucher_save.getDlgResult();
            if(result != null) {
                let deprAdjustVoucher = result.data;
                if(result.type == 'info') {
                    callback(deprAdjustVoucher, theDlg);
                } else if(result.type == 'error') {
                    MsgBox.warning(result.message);
                } else if(result.type == 'warn') {
                    self.$confirm(result.message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        dangerouslyUseHTMLString: true
                    }).then(function () {
                        callback(deprAdjustVoucher, theDlg);
                    }).catch(function () {
                    });
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbDeprInfoUpdate from './DeprInfoUpdate';
Vue.regist(SwbDeprInfoUpdate);
// 折旧信息调整
export function openDeprInfoUpdateDlg(dlgConfig, callback) {
    let row = dlgConfig['row'];
    let receiptId = dlgConfig['receiptId'];
    let bizVoucherType = dlgConfig['bizVoucherType'];
    let theDlg = Vue.$showDialog({
        title: "折旧信息 - 修改",
        width: 900,
        height: 600,
        showCloseBtn: true,
        // extVisible: true,
        extText: '试算结果',
        template: '<swb-depr-info-update :row="row" :bizVoucherType="bizVoucherType" :purchReceiptId="receiptId" ref="swb_depr_info_update"></swb-depr-info-update>',
        data: {
            row: row,
            bizVoucherType: bizVoucherType,
            receiptId: receiptId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_depr_info_update.getDlgResult() || {};
            if(result.type == 'info') {
                self.$refs.swb_depr_info_update.takeTestResult(function (deprInfo) {
                    let resultDeprInfo = result.data || {};
                    //
                    callback(deprInfo, theDlg);
                });
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        extClicked: function () {
            let self = this;
            self.$refs.swb_depr_info_update.takeTestResult();
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbAssetDeprAdjustVoucherView from './AssetDeprAdjustVoucherView';
Vue.regist(SwbAssetDeprAdjustVoucherView);

// 清理出账单查看
export function openAssetDeprAdjustVoucherDetailDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: "调整单 - 详情",
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-asset-depr-adjust-voucher-view :id="id" ref="swb_asset_depr_adjust_voucher_view"></swb-asset-depr-adjust-voucher-view>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbAssetFiscalClearVoucherAudit from './AssetFiscalClearVoucherAudit';
Vue.regist(SwbAssetFiscalClearVoucherAudit);

// 清理出账单审核
export function openAssetFiscalClearVoucherAuditDlg(applyDesc, callback) {
    //
    let theDlg = Vue.$showDialog({
        title: "清理单 - 审核",
        width: 500,
        height: 650,
        showCloseBtn: true,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-asset-fiscal-clear-voucher-audit :applyDesc="applyDesc" ref="swb_asset_fiscal_clear_voucher_audit"></swb-asset-fiscal-clear-voucher-audit>' +
        '</div>',
        data: {
            applyDesc: applyDesc
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asset_fiscal_clear_voucher_audit.getDlgResult();
            if(result.type == 'info') {
                let auditInfo = result.data;
                //
                callback(auditInfo);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

export function calculationOrgWorthDlg(taxRate, callback) {
    taxRate = taxRate == null ? 13 : taxRate;
    let theDlg = Vue.$showDialog({
        title: '按含税价计算原值',
        showCloseBtn: true,
        width: 450,
        height: 250,
        template: '<div class="simple-form">' +
        '   <div class="form-group center">' +
        '        <div class="form-label">' +
        '            <label class="required">含税价(元)</label>' +
        '        </div>' +
        '        <div class="form-value width-1-5x">' +
        '            <el-input class="align-right" type="number" size="4" v-model="wtxPrice" @change="upChange"></el-input>' +
        '        </div>' +
        '    </div>' +
        '   <div class="form-group center">' +
        '        <div class="form-label">' +
        '            <label>需调增原值(元)</label>' +
        '        </div>' +
        '        <div class="form-value width-1-5x">' +
        '            <span>{{orgWorth}}</span>' +
        '        </div>' +
        '    </div>' +
        '</div>',
        data: {
            orgWorth: 0.00,
            wtxPrice: 0
        },
        methods: {
            upChange(){
                if(Utils.isMoneyStr(this.wtxPrice) && this.wtxPrice > 0) {
                    let orgWorth = (parseFloat(this.wtxPrice) / (1 + (parseFloat(taxRate) * 0.01)));
                    this.orgWorth = orgWorth.round(2);
                } else {
                    this.orgWorth = 0;
                }
            }
        },
        okClicked: function () {
            if(this.orgWorth == null || this.orgWorth <= 0) {
                MsgBox.warning("请输入含税价！");
                return false;
            }
            callback(this.orgWorth, this.wtxPrice);
            theDlg.close();
        }
    });
}

import SwbReadyAdjustAssetConfirm from './ReadyAdjustAssetConfirm';
Vue.regist(SwbReadyAdjustAssetConfirm);
export function showReadyAdjustAssetConfirmDlg(self, receiptId, path) {
    let theDlg = Vue.$showDialog({
        title: "调整完成",
        width: 300,
        height: 200,
        showCloseBtn: true,
        okText: "查看调整单",
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-ready-adjust-asset-confirm ref="swb_ready_adjust_asset_confirm"></swb-ready-adjust-asset-confirm>' +
        '</div>',
        data: {},
        okClicked: function () {
            // 查看调整单，跳转到调整单列表
            self.$router.push({
                path: path,
                query: {
                    purchReceiptId: receiptId
                }

            });
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/assetFiscal/showDlg.js
// module id = 105
// module chunks = 0